@if((clientEntity$ | async) && (werkgeverEntity$ | async)) {
  <snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                  [useTitleBorder]="false"
                                  id="ms"
                                  size="xl"
                                  title="Vaste werknemergegevens">
    <snelstart-ui-dialog-header-content></snelstart-ui-dialog-header-content>

    <snelstart-ui-dialog-body [padding]="0">
      <snelstart-ui-tab>
        <snelstart-ui-tab-item
          (click)="onSelectTab(0)"
          [isActive]="selectedTab === 0"
          id="firstTab"
        >
          Algemeen
        </snelstart-ui-tab-item>

        <snelstart-ui-tab-item
          (click)="onSelectTab(1)"
          [isActive]="selectedTab === 1"
          id="secondTab"
        >
          Adres
        </snelstart-ui-tab-item>

        <snelstart-ui-tab-item
          (click)="onSelectTab(2)"
          [isActive]="selectedTab === 2"
          id="thirdTab"
        >
          IBAN
        </snelstart-ui-tab-item>

        <snelstart-ui-tab-item
          (click)="onSelectTab(3)"
          [isActive]="selectedTab === 3"
          id="fourthTab"
        >
          Profiel
        </snelstart-ui-tab-item>
      </snelstart-ui-tab>

      <snelstart-ui-tab-content>
        @if (selectedTab === 0) {
          <div [formGroup]="persoonFg">

            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label
                for="personeelsnummer"
                class="form-label text-muted mb-0 me-1"
              >
                Personeelsnummer
              </label>

              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.personeelsnummer">
              </snelstart-ui-tooltip-trigger>
            </div>

            <snelstart-ui-text-form-control
              [required]="true"
              class="custom-input-250"
              formControlName="personeelsnummer"
              id="personeelsnummer"
            >
            </snelstart-ui-text-form-control>

            <div class="d-flex gap-1 w-250 mb-1">
              <div class="flex-fill min-w-0">
                <div class="d-flex align-items-center label-with-tooltip">
                  <label for="voorletters" class="form-label text-muted me-1 mb-0">
                    Voorletter(s)
                  </label>
                  <snelstart-ui-tooltip-trigger
                    [tooltipTriggerConfiguration]="tooltips.voorletters">
                  </snelstart-ui-tooltip-trigger>
                </div>
              </div>

              <div class="flex-fill min-w-0">
                <label for="tussenvoegsel" class="form-label text-muted mb-0">
                  Tussenvoegsel(s)
                </label>
              </div>
            </div>

            <div class="d-flex gap-1 w-250">
              <snelstart-ui-text-form-control
                [required]="true"
                class="flex-fill min-w-0"
                formControlName="voorletters"
                id="voorletters">
              </snelstart-ui-text-form-control>

              <snelstart-ui-text-form-control
                class="flex-fill min-w-0"
                formControlName="tussenvoegsel"
                id="tussenvoegsel">
              </snelstart-ui-text-form-control>
            </div>

            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="achternaam" class="form-label text-muted me-1 mb-0">
                Achternaam
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.achternaam">
              </snelstart-ui-tooltip-trigger>
            </div>

            <snelstart-ui-text-form-control
              [required]="true"
              class="custom-input-250"
              formControlName="achternaam"
              id="achternaam">
            </snelstart-ui-text-form-control>

            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="geslacht" class="form-label text-muted me-1 mb-0">
                Geslacht
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.geslacht">
              </snelstart-ui-tooltip-trigger>
            </div>

            <snelstart-ui-select-form-control
              [required]="true"
              [options]="optionsGeslacht"
              class="custom-input-250"
              formControlName="geslacht"
              id="geslacht">
            </snelstart-ui-select-form-control>

            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="geboortedatum" class="form-label text-muted me-1 mb-0">
                Geboortedatum
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.geboortedatum">
              </snelstart-ui-tooltip-trigger>
            </div>

            <snelstart-ui-date-form-control
              [required]="true"
              class="custom-input-250"
              formControlName="geboortedatum"
              id="geboortedatum"
              label="">
            </snelstart-ui-date-form-control>

            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="nationaliteit" class="form-label text-muted me-1 mb-0">
                Nationaliteit
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.nationaliteit">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-select-form-control
              [required]="true"
              [options]="optionsNationaliteitenCode"
              class="custom-input-250"
              formControlName="nationaliteit"
              id="nationaliteit"
            >
            </snelstart-ui-select-form-control>

            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="burgerservicenummer" class="form-label text-muted me-1 mb-0">
                Burgerservicenummer
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.burgerservicenummer">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-bsn-form-control
              [required]="true"
              class="custom-input-250"
              formControlName="burgerservicenummer"
              id="burgerservicenummer"
              label=""
            >
            </snelstart-ui-bsn-form-control>
          </div>
        }

        @if (selectedTab === 1) {
          <div [formGroup]="adresFg">
            <snelstart-ui-text-form-control
              [required]="true"
              class="custom-input-250"
              formControlName="straatnaam"
              id="straatnaam"
              label="Straat"
            >
            </snelstart-ui-text-form-control>

            <div class="d-flex gap-1 w-250">
              <snelstart-ui-text-form-control
                [required]="true"
                class="custom-input-75"
                formControlName="huisnummer"
                id="huisnummer"
                label="Nummer"
              >
              </snelstart-ui-text-form-control>

              <snelstart-ui-text-form-control
                class="custom-input-60"
                formControlName="toevoeging"
                id="toevoeging"
                label="Toev.">
              </snelstart-ui-text-form-control>

              <snelstart-ui-postal-code-form-control
                [required]="true"
                class="custom-input-100"
                formControlName="postcode"
                id="postcode"
                label="Postcode"
              >
              </snelstart-ui-postal-code-form-control>
            </div>

            <snelstart-ui-text-form-control
              [required]="true"
              class="custom-input-250"
              formControlName="plaats"
              id="plaats"
              label="Plaats"
            >
            </snelstart-ui-text-form-control>

            <snelstart-ui-text-form-control
              class="custom-input-250"
              formControlName="locatieomschrijving"
              id="locatieomschrijving"
              label="Locatie omschrijving">
            </snelstart-ui-text-form-control>

            <snelstart-ui-text-form-control
              class="custom-input-250"
              formControlName="telefoonnummer"
              id="telefoonnummer"
              label="Telefoonnummer">
            </snelstart-ui-text-form-control>

            <snelstart-ui-email-form-control
              class="custom-input-250"
              formControlName="emailadres"
              id="emailadres"
              label="E-mailadres">
            </snelstart-ui-email-form-control>
          </div>
        }

        @if (selectedTab === 2) {
          <div [formGroup]="excassoFg">
            <snelstart-ui-iban-form-control
              class="custom-input-250"
              formControlName="iban"
              id="iban"
              label="IBAN">
            </snelstart-ui-iban-form-control>
          </div>
        }

        @if (selectedTab === 3) {
          <div [formGroup]="profileFg">

            <!-- Profiel -->
            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="profielId" class="form-label text-muted mb-0 me-1">
                Profiel
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.profiel">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-select-form-control
              [options]="this.optionsProfielen"
              [required]="true"
              class="flex-fill min-w-0"
              formControlName="profielId"
              [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
              id="profielId"
              label="">
            </snelstart-ui-select-form-control>

            <!-- Nummer inkomstenverhouding -->
            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="nummerIkv" class="form-label text-muted mb-0 me-1">
                Nummer inkomstenverhouding
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.nummerIkv">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-text-form-control
              [required]="true"
              class="flex-fill min-w-0"
              formControlName="nummerIkv"
              id="nummerIkv"
              [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
              label="">
            </snelstart-ui-text-form-control>

            <!-- Datum indiensttreding -->
            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="datumInDienst" class="form-label text-muted mb-0 me-1">
                Datum indiensttreding
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.datumInDienst">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-date-form-control
              [required]="true"
              class="flex-fill min-w-0"
              formControlName="datumInDienst"
              id="datumInDienst"
              [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
              label="">
            </snelstart-ui-date-form-control>

            <!-- Contractduur -->
            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="bepaaldeTijdContract" class="form-label text-muted mb-0 me-1">
                Contractduur
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.contractduur">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-select-form-control
              [options]="this.optionsJaNeeBepaaldeTijd"
              [required]="true"
              class="flex-fill min-w-0"
              formControlName="bepaaldeTijdContract"
              [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
              id="bepaaldeTijdContract"
              label="">
            </snelstart-ui-select-form-control>

            <!-- Uren per week -->
            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="urenPerWeek" class="form-label text-muted mb-0 me-1">
                Uren per week
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.urenPerWeek">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-number-form-control
              [required]="true"
              class="flex-fill min-w-0"
              formControlName="urenPerWeek"
              [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
              id="urenPerWeek"
              label="">
            </snelstart-ui-number-form-control>

            <!-- Periodesalaris -->
            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="periodeSalaris" class="form-label text-muted mb-0 me-1">
                Periodesalaris bij aanvang
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.periodeSalaris">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-number-form-control
              [required]="true"
              class="flex-fill min-w-0"
              formControlName="periodeSalaris"
              prefix="€"
              [align]="right"
              [showAllDecimals]="true"
              [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
              id="periodeSalaris"
              label="">
            </snelstart-ui-number-form-control>

            <!-- LHK -->
            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="lhkToepassen" class="form-label text-muted mb-0 me-1">
                Loonheffingskorting toepassen?
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.lhk">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-select-form-control
              [options]="this.optionsJaNee"
              [required]="true"
              class="flex-fill min-w-0"
              formControlName="lhkToepassen"
              [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
              id="lhkToepassen"
              label="">
            </snelstart-ui-select-form-control>

            <!-- Vakantiegeld reserveren -->
            <div class="d-flex align-items-center mb-1 label-with-tooltip">
              <label for="rechtOpVakantiegeld" class="form-label text-muted mb-0 me-1">
                Vakantiegeld reserveren?
              </label>
              <snelstart-ui-tooltip-trigger
                [tooltipTriggerConfiguration]="tooltips.vakantiegeld">
              </snelstart-ui-tooltip-trigger>
            </div>
            <snelstart-ui-select-form-control
              [options]="this.optionsJaNee"
              [required]="true"
              class="flex-fill min-w-0"
              formControlName="rechtOpVakantiegeld"
              [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
              id="rechtOpVakantiegeld"
              label="">
            </snelstart-ui-select-form-control>

            @if(this.profileFg.getRawValue().rechtOpVakantiegeld) {

              <div class="d-flex align-items-center mb-1 label-with-tooltip">
                <label for="percentageVakantiegeld" class="form-label text-muted mb-0 me-1">
                  Percentage vakantiegeld
                </label>
              </div>

              <snelstart-ui-number-form-control
                [required]="true"
                class="flex-fill min-w-0"
                formControlName="percentage"
                [prefix]="'%'"
                [align]="right"
                [showAllDecimals]="true"
                [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
                id="percentage"
                label="">
              </snelstart-ui-number-form-control>

              <!-- Periode vrijval -->
              <div class="d-flex align-items-center mb-1 label-with-tooltip">
                <label for="periodeVrijval" class="form-label text-muted mb-0 me-1">
                  Periode vrijval
                </label>
                <snelstart-ui-tooltip-trigger
                  [tooltipTriggerConfiguration]="tooltips.periodeVrijval">
                </snelstart-ui-tooltip-trigger>
              </div>
              <snelstart-ui-select-form-control
                [options]="this.optionsVrijval"
                [required]="true"
                class="flex-fill min-w-0"
                formControlName="periodeVrijval"
                [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
                id="periodeVrijval"
                label="">
              </snelstart-ui-select-form-control>

              <div class="d-flex align-items-center mb-1 label-with-tooltip">
                <label for="grondslagComponenten" class="form-label text-muted mb-0 me-1">
                  Grondslag reservering
                </label>
              </div>

              <select
                class="form-select custom-input-250"
                formControlName="grondslagComponenten"
                id="grondslagComponenten"
                multiple>
                <option
                  *ngFor="let opt of optionsGrondslagComponenten"
                  [ngValue]="opt.value">
                  {{ opt.text }}
                </option>
              </select>

              <!-- Reeds opgebouwd recht vakantiegeld -->
              <div class="d-flex align-items-center mb-1 label-with-tooltip">
                <label for="vakantiegeldBijAanvang" class="form-label text-muted mb-0 me-1">
                  Reeds opgebouwd recht vakantiegeld
                </label>
                <snelstart-ui-tooltip-trigger
                  [tooltipTriggerConfiguration]="tooltips.vakantiegeldBijAanvang">
                </snelstart-ui-tooltip-trigger>
              </div>
              <snelstart-ui-number-form-control
                class="flex-fill min-w-0"
                formControlName="vakantiegeldBijAanvang"
                prefix="€"
                [align]="right"
                [showAllDecimals]="true"
                [disabledControl]="this.profileFg.get('reset')?.getRawValue()"
                id="vakantiegeldBijAanvang"
                label="">
              </snelstart-ui-number-form-control>
            }

          </div>
        }
      </snelstart-ui-tab-content>
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button
        (click)="this.onClose()"
        btn-x
        class="me-2"
        id="cancel"
        type="secondary">
        Annuleren
      </snelstart-ui-button>

      @if (isEditMode) {
        @if (selectedTab !== 3) {
          <snelstart-ui-button
            (click)="persistWerknemer()"
            [disabled]="!persoonFg.valid"
            icon="check"
            id="save-fixed"
            ignoreClick
            type="primary">
            Opslaan
          </snelstart-ui-button>
        }

        @if (selectedTab === 3) {
          <snelstart-ui-button
            [disabled]="true"
            icon="check"
            id="save-profile-disabled"
            type="primary">
            Opslaan
          </snelstart-ui-button>
        }
      }

      @if (!isEditMode) {
        @if (selectedTab !== 3) {
          <snelstart-ui-button
            (click)="onSelectTab(selectedTab + 1)"
            [disabled]="selectedTab === 0 && !persoonFg.valid"
            icon="check"
            id="next"
            ignoreClick
            type="primary">
            Volgende
          </snelstart-ui-button>
        }

        @if (selectedTab === 3) {
          <snelstart-ui-button
            (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
            (click)="handleSubmit(); this.dialogVisibleChange.emit(false)"
            [disabled]="!persoonFg.valid  || !adresFg.valid || !profileFg.valid"
            icon="check"
            id="save"
            type="primary">
            Opslaan
          </snelstart-ui-button>
        }
      }
    </snelstart-ui-dialog-buttons>

  </snelstart-ui-dialog-definition>
}

